import { useLocation } from "react-router-dom";

const faNumber = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
const enNumber = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

export const validNumber = (e: any) => {
  let value: any = [];
  value = e.value;
  var result = "";
  for (let element of value) {
    result += checkNumber(faNumber, enNumber, element);
    result += checkNumber(enNumber, enNumber, element);
  }
  return result;
};

const checkNumber = (inputArray: any, outputArray: any, char: any) => {
  var charIndex = inputArray.indexOf(char);
  if (charIndex < 0) {
    return "";
  } else {
    return outputArray[charIndex];
  }
};

export const getQsByKey = () => {
  const location = useLocation();
  const search = location.search;
  const params = new URLSearchParams(search);
  return params;
};

export function addComma(x: any) {
  return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}
